var React = require('react');

function IconCheckBase (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.3335 8.10558L5.73544 12.6666L14.6668 3.33331","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconCheckBase.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconCheckBase;

IconCheckBase.default = IconCheckBase;
